import { ActType } from '../type';
import { CouponActivity } from './coupon-activity';
import { getServerTime } from '@tencent/wphk-components-common/utils/server-time';
import { qryUserQual } from '@tencent/wphk-act-base-cgi';
import { handleQryCoupon, QryCouponType } from '../../business/activity/qry-coupon';
import { GetCouponType, handleGetCoupon } from '../../business/activity/get-coupon';
import { checkUserActStatus } from '../../business';
/**
 * 印花资格兑换券活动类
 */
export class StampQualActivity extends CouponActivity {
    constructor(stampQualActivityOpts) {
        super(stampQualActivityOpts.couponActRelation);
        /** 活动类型 */
        this.type = ActType.stampQualLimit;
        /** 印花信息 */
        this.stampInfo = {
            stampBatchNo: '',
            stampData: {
                userMaxCount: 0,
                userTotalCount: 0,
                userUsedCount: 0,
                isExpired: false,
                userRemainCount: 0,
            },
        };
        /** 印花信息 */
        this.stampInfo = Object.assign(this.stampInfo, stampQualActivityOpts.stampInfo);
    }
    /** 初始化活动信息 */
    async initAct() {
        /** 拉取印花 */
        await this.getUserStampData();
        /** 拉取券列表 */
        await this.qryCoupon();
    }
    /** 参与活动 */
    async execAct() {
        if (super.beforeExecAct()) {
            // getCoupon
        }
    }
    /** 查询并设置活动状态 */
    async setActState() { }
    /** 设置是否可以参与活动 */
    async setHasQual(actInfo) {
        const userQual = await checkUserActStatus([actInfo]);
        console.log('userQual: ', userQual);
    }
    /** 查询并设置用户参与活动状态 */
    async setUserActState() { }
    /** 根据印花批次号查用户印花信息 */
    async getUserStampData() {
        const data = await qryUserQual({ qualId: this.stampInfo.stampBatchNo });
        this.stampInfo.stampData = {
            /* 获得印花数 */
            userTotalCount: data.totalCnt,
            /* 已使用印花数 */
            userUsedCount: data.usedCnt,
            /* 用户最多印花资格数 */
            userMaxCount: data.userMaxCnt,
            /** 是否已失效 */
            isExpired: getServerTime().getTime() > data.exchEndTime.getTime(),
            /** 用户印花剩余 */
            userRemainCount: data.totalCnt - data.usedCnt,
        };
    }
    /** 查券 */
    async qryCoupon() {
        const couponList = await handleQryCoupon[QryCouponType.ExchActPrizeInfoByQualId](this.type, this.couponActRelation, this.stampInfo);
        this.couponList = couponList;
    }
    /** 领券 */
    async getCoupon(params) {
        if (!params)
            throw new Error('参数错误');
        // 查券类型
        const { getCouponType } = params;
        // 非互斥
        if (getCouponType === GetCouponType.ExchangePrize) {
            const { qualId, actListid, prizeId } = params;
            if (!qualId || !actListid || !prizeId)
                throw new Error('参数错误');
            return await handleGetCoupon[GetCouponType.ExchangePrize](qualId, actListid, prizeId);
        }
        // 互斥
        if (getCouponType === GetCouponType.MulactionExchangePrize) {
            const { qualId, actId } = params;
            if (!qualId || !actId)
                throw new Error('参数错误');
            return await handleGetCoupon[GetCouponType.MulactionExchangePrize](qualId, actId);
        }
    }
    /** 获取用户领到的券 */
    async getUserCouponList() { }
}
